export class SaveMessages {
	private _saveSuccess : boolean;
	private _saveFailed: boolean;
	private _deleteSuccess: boolean;
	private _deleteFailed: boolean;
	
	constructor() {
		this.reset();
	}
	
	public reset() : void {
		this.saveFailed = false;
		this.saveSuccess = false;
		this._deleteSuccess = false;
		this._deleteFailed = false;
	}
	
	public get deleteSuccess() : boolean {
		return this._deleteSuccess;
	}
	
	public set deleteSuccess(v : boolean) {
		this._deleteSuccess = v;
	}
	
	public get deleteFailed() : boolean {
		return this._deleteFailed;
	}
	
	public set deleteFailed(v : boolean) {
		this._deleteFailed = v;
	}
	
	
	public get saveSuccess() : boolean {
		return this._saveSuccess;
	}
	
	public set saveSuccess(v : boolean) {
		this._saveSuccess = v;
	}
	
	public get saveFailed() : boolean {
		return this._saveFailed;
	}
	
	public set saveFailed(v : boolean) {
		this._saveFailed = v;
	}
	
	
}


// WEBPACK FOOTER //
// ./src/app/shared/models/save-messages.ts